import { createRoot } from "react-dom/client";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";
import { NotFoundComponent } from "@/components/NotFoundComponent";
import { config } from "zod";
import "./styles/index.css";

// Zod v4 probes for eval via `new Function` at module init to decide whether it
// can use a JIT error formatter. Under a strict CSP (script-src without
// 'unsafe-eval') that probe fires a securitypolicyviolation even though the
// throw is caught. Opt out of the JIT path so no eval ever runs.
config({ jitless: true });

// Create a client
const queryClient = new QueryClient();

// Create the router
const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <NotFoundComponent />,
});

// Register the router for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.querySelector("#root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <RouterProvider router={router} />
    </TooltipProvider>
  </QueryClientProvider>,
);
